import { useSelector, useDispatch } from 'react-redux';

import DataGrid from 'app/components/DataGrid';
import classes from 'app/components/DataGrid/classes.module.scss';
import useAccessCodePages from 'app/hooks/useAccessCodePages';
import AccessCodePageModal from './AccessCodePageModal';

import {
  pageModeOptions
} from 'app/utils/options';

import {
  formatPageModeCellValue
} from 'app/utils/valueFormatters';

const AccessCodePages = () => {
  const {
    resource,
    formIsOpen,
    currentRecord,
    onFormClose,
    onAdd,
    onEdit,
    onDataGridLoad,
    onFormSubmit,
    onDestroy,
    showFilters,
    getRowData,
    updateRow
  } = useAccessCodePages();

  const header = 'Access Code Pages';
  const addButtonLabel = 'Add Page';

  const columnOrder = [
    'page_mode',
    'logo_url',
    'created_at',
    'account_id',
    'account_name',
    'subdomain',
    'allow_name',
    'require_name',
    'allow_email',
    'require_email',
    'allow_phone',
    'require_phone',
    'allow_metadata',
    'allow_zip',
    'require_zip',
    'opt_in_message',
    'opt_in_checked',
    'registration_message',
    'delay_access',
    'has_background',
    'background_color',
    'logo_mime_type',
    'has_video',
    'video_mime_type',
    'background_gravity',
    'logo_height',
    'header',
    'button_color',
    'head_title',
    'head_description',
    'contact_email',
    'id'
  ]

  const visibleColumns = columnOrder;

  const columnDefOverrides = [
    {
      field: 'logo_url',
      headerName: 'Logo',
      pinned: 'left',
      thumbnail: data => data && data.logo_url,
    },
    {
      field: 'created_at',
      headerName: 'Created At',
      minWidth: 20 * 16, // 20rem
      inputType: 'date',
      renderFields: [
        { field: 'created_at', type: 'date' },
        { field: 'updated_at', type: 'date', dateStyle: 'short', prefix: 'Updated ' }
      ]
    },
    {
      field: 'account_id',
      headerName: 'Account ID'
    },
    {
      field: 'account_name',
      headerName: 'Account Name'
    },
    {
      field: 'subdomain',
      headerName: 'Subdomain'
    },
    {
      field: 'allow_name',
      headerName: 'Allow Name'
    },
    {
      field: 'require_name',
      headerName: 'Require Name'
    },
    {
      field: 'allow_email',
      headerName: 'Allow Email'
    },
    {
      field: 'require_email',
      headerName: 'Require Email'
    },
    {
      field: 'allow_phone',
      headerName: 'Allow Phone'
    },
    {
      field: 'require_phone',
      headerName: 'Require Phone'
    },
    {
      field: 'allow_metadata',
      headerName: 'Allow Metadata'
    },
    {
      field: 'allow_zip',
      headerName: 'Allow Zip'
    },
    {
      field: 'require_zip',
      headerName: 'Require Zip'
    },
    {
      field: 'opt_in_message',
      headerName: 'Opt In Message'
    },
    {
      field: 'opt_in_checked',
      headerName: 'Opt In Checked'
    },
    {
      field: 'registration_message',
      headerName: 'Registration Message'
    },
    {
      field: 'delay_access',
      headerName: 'Delay Access'
    },
    {
      field: 'has_background',
      headerName: 'Has Background'
    },
    {
      field: 'background_color',
      headerName: 'Background Color'
    },
    {
      field: 'logo_mime_type',
      headerName: 'Logo Mime Type'
    },
    {
      field: 'has_video',
      headerName: 'Has Video'
    },
    {
      field: 'video_mime_type',
      headerName: 'Video Mime Type'
    },
    {
      field: 'background_gravity',
      headerName: 'Background Gravity'
    },
    {
      field: 'logo_height',
      headerName: 'Logo Height'
    },
    {
      field: 'header',
      headerName: 'Header'
    },
    {
      field: 'button_color',
      headerName: 'Button Color'
    },
    {
      field: 'head_title',
      headerName: 'Head Title'
    },
    {
      field: 'head_description',
      headerName: 'Head Description'
    },
    {
      field: 'contact_email',
      headerName: 'Contact Email'
    },
    {
      field: 'id',
      headerName: 'ID'
    },
    {
      field: 'page_mode',
      headerName: 'Page Mode',
      valueFormatter: value => formatPageModeCellValue(value),
      inputType: 'select',
      inputOptions: pageModeOptions,
      quickEdit: true
    },
  ]

  const callback = selectedRows => {
    console.log(selectedRows);
  }

  const actions = [
    { key: 'destroy', label: 'Delete Page', callback }
  ]

  return (
    <div>
      <DataGrid
        resource={resource}
        header={header}
        getRowData={getRowData}
        addButtonLabel={addButtonLabel}
        onAdd={onAdd}
        showEdit={true}
        onEdit={onEdit}
        columnOrder={columnOrder}
        columnDefOverrides={columnDefOverrides}
        visibleColumns={visibleColumns}
        showFilters={showFilters}
        showSelect={true}
        actions={actions}
        loadingMessage="Loading pages..."
        onDataGridLoad={onDataGridLoad}
      />
      <AccessCodePageModal
        isOpen={formIsOpen}
        onClose={onFormClose}
        accessCodePage={currentRecord}
        onFormSubmit={onFormSubmit}
        onDestroy={onDestroy}
        updateRow={updateRow}
      />
    </div>
  );
}

export default AccessCodePages;
